import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "34",
  height: "34",
  fill: "none",
  viewBox: "0 0 34 34"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#f0f7ff",
      d: "M0 8a8 8 0 0 1 8-8h18a8 8 0 0 1 8 8v18a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#006aff",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M23 18.5a6 6 0 1 1-11.564-2.25C12.326 14.051 17 9.5 17 9.5s4.674 4.551 5.564 6.75c.281.695.436 1.454.436 2.25"
    }, null, -1)
  ]))]))
}
export default { render: render }